import { IMenhirPocket } from './pockets.types';
import { IPocket } from './pockets.types';

export const transformPocket = (menhirPocket: IMenhirPocket): IPocket => ({
  id: menhirPocket.id,
  hasMovements: menhirPocket.has_movements,
  ownerId: menhirPocket.owner_id,
  ownerType: menhirPocket.owner_type,
  providerId: menhirPocket.provider_id,
  type:
    menhirPocket.type === 'budget'
      ? ('budgets' as IPocket['type'])
      : menhirPocket.type,
  balance: menhirPocket.balance,
  merchantCodes: menhirPocket.merchant_codes,
  hasAddedCredits: menhirPocket.has_added_credits,
});
